interface MadrielLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const MadrielLogo = ({ className = '', width = 66.35, height = 17.04 }: MadrielLogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 66.35 17.04"
      width={width}
      height={height}
      className={className}
    >
      <defs>
        <style>
          {`
            .letter {
              animation: glowWave 10s infinite ease-in-out;
            }

            /* M je růžové */
            #letter-m { 
              fill: #b71b90; 
              animation-delay: 0s; 
            }

            /* Ostatní jsou šedá se zpožděním */
            #letter-a { fill: #515151; animation-delay: 0.15s; }
            #letter-d { fill: #515151; animation-delay: 0.3s; }
            #letter-r { fill: #515151; animation-delay: 0.45s; }
            #letter-i { fill: #515151; animation-delay: 0.6s; }
            #letter-e { fill: #515151; animation-delay: 0.75s; }
            #letter-l { fill: #515151; animation-delay: 0.9s; }

            @keyframes glowWave {
              0%, 25%, 100% {
                filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
                opacity: 1;
              }
              12% {
                /* Barva záře je u M růžová, u ostatních bílá/světle šedá */
                filter: drop-shadow(0 0 2px #b71b90) brightness(1.3);
              }
            }
            
            /* Specifická barva záře pro šedá písmena, aby nepůsobila růžově */
            #letter-a, #letter-d, #letter-r, #letter-i, #letter-e, #letter-l {
              animation-name: glowWaveGrey;
            }

            @keyframes glowWaveGrey {
              0%, 25%, 100% {
                filter: drop-shadow(0 0 0px rgba(255, 255, 255, 0));
              }
              12% {
                filter: drop-shadow(0 0 2px rgba(180, 180, 180, 0.8)) brightness(1.5);
              }
            }
          `}
        </style>
      </defs>
      <g id="Madriel">
        {/* M */}
        <path id="letter-m" className="letter" d="M1.67,2.73c.6-.32,1.19-.48,1.77-.48s1.11.12,1.6.37c.97.5,1.79,1.32,2.48,2.45l2.27,3.7,3.78-5.63h.11l1.44,7.44c.29,1.53.72,2.58,1.28,3.18.45.47,1.02.7,1.72.7h.19v.13c-.53.22-1.07.33-1.64.33-1.13,0-2.11-.44-2.94-1.32-.69-.73-1.18-1.76-1.46-3.09l-.58-2.68-2.17,3.23c-.14.2-.27.45-.38.74-.11.29-.16.53-.15.74h-.11l-3.09-5.29c-.01.11-.45,2.97-.68,4.33-.26,1.54-2.43,1.91-2.43,1.91v-.09c.34-.19,1.3-.79,1.5-2.08l.88-5.45c-.43-.75-.91-1.42-1.44-2.01-.6-.66-1.2-.99-1.8-.99h-.1l-.04-.13Z" />
        
        {/* A */}
        <path id="letter-a" className="letter" d="M25.51,12.91h.1v.12h-4.55v-.12h.11c.18,0,.31-.05.4-.16.09-.11.13-.21.13-.3s-.02-.19-.06-.29l-.47-1.12h-2.57l-.48,1.12c-.04.1-.06.19-.06.25s.01.13.04.21c.03.08.09.14.18.2s.19.09.29.09h.11v.12h-2.68v-.12h.11c.18,0,.37-.05.55-.16.18-.11.33-.27.45-.49l2.8-6.13c.42-.9.65-1.49.68-1.79h.11l3.8,7.91c.26.44.59.66,1.01.66ZM18.86,10.44h2.05l-1.01-2.4-1.04,2.4Z" />
        
        {/* D */}
        <path id="letter-d" className="letter" d="M33.54,5.74c.84.74,1.27,1.77,1.27,3.09s-.42,2.35-1.27,3.09c-.84.74-2.02,1.11-3.52,1.11h-4.55v-.12h.16c.21,0,.39-.07.53-.22.15-.15.23-.33.23-.53v-6.72c0-.19-.08-.35-.23-.49s-.33-.2-.53-.2h-.14v-.12s4.54,0,4.54,0c1.5,0,2.68.37,3.52,1.11ZM28.86,5.23v7.2h.92c.74,0,1.33-.32,1.75-.95.42-.64.64-1.52.64-2.65s-.21-2.01-.64-2.65c-.42-.64-1.01-.95-1.75-.95h-.92Z" />
        
        {/* R */}
        <path id="letter-r" className="letter" d="M42.42,5.95c.13.28.19.57.19.87s-.03.56-.1.79c-.06.23-.16.45-.3.68-.3.48-.8.78-1.52.89.31.09.59.24.84.47.26.22.51.54.74.94.6,1.02,1.06,1.68,1.38,1.98.24.22.54.34.91.35v.12h-1.5c-1.04,0-1.78-.12-2.23-.35-.64-.33-1.1-.89-1.37-1.69-.07-.23-.13-.48-.19-.73s-.1-.44-.13-.56c-.04-.12-.08-.22-.13-.32s-.1-.18-.16-.23c-.1-.1-.21-.17-.34-.22v-.12h.19c.46,0,.81-.21,1.04-.64.12-.22.19-.47.22-.73s.04-.42.04-.49v-.12c-.06-1.06-.51-1.58-1.37-1.58h-.53v6.9c0,.21.08.39.23.53s.33.22.54.22h.14v.12h-4.31v-.12h.16c.21,0,.39-.07.53-.22.15-.14.23-.32.23-.53v-6.66c0-.3-.14-.52-.38-.66-.12-.06-.25-.1-.38-.1h-.16v-.12h4.69c1.57,0,2.56.44,2.99,1.32Z" />
        
        {/* I */}
        <path id="letter-i" className="letter" d="M44.34,12.91c.21,0,.39-.07.53-.22.15-.15.23-.33.23-.53v-6.66c0-.21-.09-.38-.23-.53-.15-.14-.33-.22-.53-.22h-.16v-.12h4.31v.12h-.16c-.21,0,.39.07-.53.22-.15.14-.23.32-.23.53v6.66c0,.21.08.39.23.53.15.15.33.22.54.22h.16v.12h-4.31v-.12h.16Z" />
        
        {/* E */}
        <path id="letter-e" className="letter" d="M49.36,12.91c.21,0,.39-.07.53-.22.15-.15.23-.33.23-.53v-6.65c0-.26-.12-.46-.32-.61-.13-.1-.28-.14-.44-.14h-.16v-.12h5.32c.34,0,.65-.06.92-.08.42-.04.65-.4.72-.43l-.21,2.77h-.12v-.1c0-.64-.23-1.09-.7-1.34-.22-.13-.49-.2-.8-.2h-1.74v3.35h1.31c.38,0,.7-.13.94-.38.24-.24.36-.56.36-.94v-.05h.12v3.34h-.12v-.06c0-.38-.12-.69-.36-.93-.24-.24-.55-.37-.92-.38h-1.32v3.23h1.48c.58,0,1.1-.19,1.55-.58.45-.38.76-.92.95-1.6h.12l-.46,2.78h-7.02v-.12h.16Z" />
        
        {/* L */}
        <path id="letter-l" className="letter" d="M57.25,12.91c.21,0,.39-.07.53-.22.15-.15.23-.33.23-.53v-6.65c0-.3-.14-.52-.38-.66-.12-.06-.25-.1-.38-.1h-.16v-.12h4.31v.12h-.16c-.21,0,.39.07-.54.22-.15.15-.23.33-.23.53v6.91h1.48c.58,0,1.1-.19,1.55-.58.45-.38.76-.92.95-1.6h.12l-.46,2.78h-7.02v-.12h.16Z" />
      </g>
    </svg>
  );
};

export default MadrielLogo;